/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface SearchResultError
 */
export interface SearchResultError {
    /**
     * 
     * @type {string}
     * @memberof SearchResultError
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultError
     */
    message?: string;
}

/**
 * Check if a given object implements the SearchResultError interface.
 */
export function instanceOfSearchResultError(value: object): boolean {
    return true;
}

export function SearchResultErrorFromJSON(json: any): SearchResultError {
    return SearchResultErrorFromJSONTyped(json, false);
}

export function SearchResultErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultError {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function SearchResultErrorToJSON(value?: SearchResultError | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'message': value['message'],
    };
}

